import React from 'react';

import WidgetComponent from '../../widget/WidgetComponent';
import Widget from '../../widget/Widget';
import WidgetModal from '../../widget/WidgetModal';
import Config from '../../config/Config';
import WidgetInterfaceTable from '../../widget/WidgetInterfaceTable';


import '../../css/analysis.css';

class DealInfo extends WidgetComponent
{
    constructor(props)
    {
        super(props);

        let url = Config.getHermesPanoramaURL();
        let UID = Config.getHermesPanoramaUID();
        let entname = Widget.getSessionStorage("entname");

        this.state = {
            options:{
                'url':url,
                'records':20,
                'title':'招投标'
            },
            columns:[
                {name:'TITLE', title:'项目名称', type:'string', properties:{"click":"objectDetail"}},
                {name:'PURCHASER', title:'采购人', type:'string'},
                {name:'ISSDATE', title:'发布日期', type:'date'},
                {name:'MSGAREA', title:'标讯区域', type:'string', properties:{"hidden":true}},
                {name:'AREA', title:'地区', type:'string', properties:{"hidden":true}},
                {name:'AGENCY', title:'代理机构', type:'string', properties:{"hidden":true}}, 
                {name:'BIDNO', title:'招标编号', type:'string', properties:{"hidden":true}},
                {name:'ANNCCONTENT', title:'公告正文', type:'string', properties:{"hidden":true}},
            ],
            params :{
                'service':'getBiddingInfo',
                'user':UID,
                'ENTNAME' : entname
            },
            objectOptions:{
                name:"object",
                title:"招聘详情",
                size:"md",
            },
            objectData:{
                MSGAREA: "",
                AREA: "",
                TITLE: "",
                PURCHASER: "",
                AGENCY: "",
                BIDNO: "",
                ISSDATE: "",
                ANNCCONTENT: ""
            }
        };

        this.onLoadToken = this.onLoadToken.bind(this);
        this.notify = this.notify.bind(this);

        Config.getHermesAccess( this.onLoadToken );
    }

    /**
     * 获取 token 回调函数
     * @param {*} result 
     * @returns 
     */
    onLoadToken( result )
    {
        let { params } = this.state;
        if( result.status===0 )
        {
            params["access"] =  result.result.token;
 
            this.setState({params:params}); 
        }
        else
        {
            return ;
        }  
    }

    onRef = (ref) => {

        if( ref.props.options.name === "object" )
        {
            this.objectModal =  ref ;
        }
        
    }

    notify(type, data, value) 
    {
        switch( type )
        {
            case "objectDetail":
            {
                let { objectOptions } = this.state;

                objectOptions["title"] = value;

                data = JSON.parse(data);
                
                this.setState({
                    objectData:{
                        MSGAREA:data.MSGAREA,
                        AREA: data.AREA,
                        TITLE: data.TITLE,
                        PURCHASER: data.PURCHASER,
                        AGENCY: data.AGENCY,
                        BIDNO: data.BIDNO,
                        ISSDATE: data.ISSDATE,
                        ANNCCONTENT: data.ANNCCONTENT,
                    },
                    objectOptions:objectOptions
                })
                
                this.objectModal.open();

                break;
            }
            default :
                break;
        }
    }

    componentDidUpdate( )
    {
        let entname = Widget.getSessionStorage("entname");

        let { params } = this.state;

        if( params.ENTNAME!==entname )
        {
            this.state["params"]["ENTNAME"] = entname;
            Config.getHermesAccess( this.onLoadToken );
        }  
    }

    render() 
	{
        const {options, columns, params, objectOptions, objectData } = this.state;
        
        return(
            <div className="page">
                <div className="page-content page-overflow height-100 white padding-20">
                    <div className="content-top">
                        <WidgetInterfaceTable options={options} columns={columns} params={params} notify={this.notify}/>
                    </div>

                    {/* 招投标弹出框 */}
                    <WidgetModal options={objectOptions} onRef={this.onRef}>
                        <div className="baseInfo">
                        <table>
				            <tbody id="show_data">
                                <tr>
                                    <td class="detail_td_1">标讯区域</td>
                                    <td class="detail_td_2" id="">{objectData.MSGAREA}</td>
                                    <td class="detail_td_1">地区</td>
                                    <td class="detail_td_2" id="">{objectData.AREA}</td>
                                </tr>
                                <tr>
                                    <td class="detail_td_1">标题</td>
                                    <td class="detail_td_2" id="">{objectData.TITLE}</td>
                                    <td class="detail_td_1">采购人</td>
                                    <td class="detail_td_2" id="">{objectData.PURCHASER}</td>
                                </tr>
                                <tr>
                                    <td class="detail_td_1">代理机构</td>
                                    <td class="detail_td_2" id="">{objectData.AGENCY}</td>
                                    <td class="detail_td_1">招标编号</td>
                                    <td class="detail_td_2" id="">{objectData.BIDNO}</td>
                                </tr>
                                <tr>
                                    <td class="detail_td_1">发布日期</td>
                                    <td class="detail_td_2" id="">{objectData.ISSDATE}</td>
                                    <td class="detail_td_1">公告正文</td>
                                    <td class="detail_td_2" id="">{objectData.ANNCCONTENT}</td>
                                </tr>
                            </tbody>
			            </table>
                        </div>
                    </WidgetModal>
                </div>
            </div>
        );
    }

}

export default DealInfo